'use client';

import { Carousel } from '@c/index';
import { useQuery } from '@tanstack/react-query';
import { getLiveAuctions } from '@util/firestore/products';
import { renderProductCards } from 'features/homepage/utils';
import { ProductLight } from 'models/product';
import HomeSection from '../Home/components/HomeSection';

export default function LiveAuctions({
  auctionsFromBundle,
}: {
  auctionsFromBundle: ProductLight[];
}) {
  const { data: liveAuctions } = useQuery({
    queryKey: ['liveAuctions'],
    queryFn: () => getLiveAuctions(),
    placeholderData: () => auctionsFromBundle,
    select: (data) => {
      const updatedAuctions: ProductLight[] = [];
      // update prices from liveAuctions
      auctionsFromBundle.forEach((auction) => {
        const liveAuction = data.find((a) => a.id === auction.id);
        if (liveAuction?.price)
          updatedAuctions.push({ ...auction, price: liveAuction.price });
      });
      // add live auctions that are not in the bundle
      data.forEach((auction) => {
        if (!updatedAuctions.some((a) => a.id === auction.id))
          updatedAuctions.push(auction);
      });
      return updatedAuctions;
    },
  });
  if (!liveAuctions?.length) return null;
  return (
    <HomeSection
      title={'Live Auctions'}
      linkText={'See All'}
      href={'/shop/auctions'}
      carouselWrapper
    >
      <Carousel
        className="-mt-12"
        spacing={0}
        basis="basis-[48%] sm:basis-auto"
        items={renderProductCards(
          liveAuctions,
          {},
          {
            data_source: 'firebase',
            page: 'home',
            section: 'live-auctions',
          }
        )}
      />
    </HomeSection>
  );
}
